// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1k1l8","form":"styles_form__jQlvH"};